/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCodebookRequest } from '../models/CreateCodebookRequest';
import type { PageableCodebookResponse } from '../models/PageableCodebookResponse';
import type { SingleCodebookResponse } from '../models/SingleCodebookResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CodebookApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create codebook
   * @param requestBody
   * @returns any Create codebook
   * @throws ApiError
   */
  public createCodebook(
    requestBody?: CreateCodebookRequest,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/warehouses',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get Codebook
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns PageableCodebookResponse Get codebook
   * @throws ApiError
   */
  public getCodebook(
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<PageableCodebookResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/warehouses',
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get Codebook by id
   * @param id
   * @returns SingleCodebookResponse Get codebook response
   * @throws ApiError
   */
  public getCodebookById(
    id: string,
  ): CancelablePromise<SingleCodebookResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/warehouses/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Update
   * @param id
   * @param requestBody
   * @returns SingleCodebookResponse Update
   * @throws ApiError
   */
  public updateCodebook(
    id: string,
    requestBody?: CreateCodebookRequest,
  ): CancelablePromise<SingleCodebookResponse> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/warehouses/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * delete
   * @param id
   * @returns any deleted
   * @throws ApiError
   */
  public deleteCodebook(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/warehouses/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * publish
   * @param id
   * @param requestBody
   * @returns any publish
   * @throws ApiError
   */
  public publishCodebook(
    id: string,
    requestBody?: {
      isPublic: boolean;
    },
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/warehouses/{id}/publish',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
